var defaultAPI = function defaultAPI() {
  return console.warn('please register the navigation API');
}; //eslint-disable-line


var navigationAPI = defaultAPI;
export var registerNavigationAPI = function registerNavigationAPI(api) {
  navigationAPI = api;
};
export default (function (args) {
  return navigationAPI(args);
});